import styled from 'styled-components';

export const FormStyled = styled.div`
    ${({ theme }) => theme.mixins.gridRowCenter};
    width: 100%;
    grid-auto-columns: 100%;
`;
